import React, { useState, useContext, useEffect } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import "./staffInfoModal.css";
import companyBasedRequest from "../../../request/companyBasedRequest";
import translations from "../../../translations/translations";
import PhoneInput from "../../common/phoneInput/phoneInput"; // adjust to mobile app's path

const StaffInfoModal = ({ open, onClose, staff, setStaff }) => {
    const { language, userData, setUserData } = useContext(CombinedContext);

    const [local, setLocal] = useState({
        firstName: "",
        lastName: "",
        bio: "",
        phone: "",
    });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!staff) return;
        setLocal({
            firstName: staff.firstName || "",
            lastName: staff.lastName || "",
            bio: staff.bio || "",
            phone: staff.phone || "",
        });
    }, [staff]);

    if (!open) return null;

    const handleSave = async () => {
        const cardData = {
            firstName: local.firstName,
            lastName: local.lastName,
            bio: local.bio,
            phone: local.phone,
        };
        const apiData = {
            firstName: local.firstName,
            lastName: local.lastName,
            bio: local.bio,
            phoneNumber: local.phone,
        };

        setStaff((prev) => ({ ...prev, ...cardData }));
        setUserData((prev) => ({
            ...prev,
            user: { ...prev.user, ...apiData },
        }));

        try {
            setSaving(true);
            await companyBasedRequest.updateStaffInfo(
                staff.userId,
                apiData,
                userData.cognitoTokens.AccessToken
            );
            onClose();
        } catch (err) {
            console.error("Failed to update staff info", err);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="sf-book-overlay" onClick={onClose}>
            <div className="sf-book-modal" onClick={(e) => e.stopPropagation()}>
                <div className="sf-profile-modal-header">
                    <h2>{translations[language].profileStaff.staffInfo.title}</h2>{" "}
                    <button className="sf-book-close" onClick={onClose}>
                        ✕
                    </button>
                </div>

                <div className="sf-book-body">
                    <label>{translations[language].profileStaff.staffInfo.firstName}</label>
                    <input
                        className="sf-staff-input"
                        value={local.firstName}
                        onChange={(e) => setLocal({ ...local, firstName: e.target.value })}
                    />

                    <label>{translations[language].profileStaff.staffInfo.lastName}</label>
                    <input
                        className="sf-staff-input"
                        value={local.lastName}
                        onChange={(e) => setLocal({ ...local, lastName: e.target.value })}
                    />

                    <label>{translations[language].profileStaff.staffInfo.phone}</label>
                    <PhoneInput
                        businessPhone={local.phone}
                        setBusinessPhone={(value) => setLocal((prev) => ({ ...prev, phone: value }))}
                    />

                    <label>{translations[language].profileStaff.staffInfo.bio}</label>
                    <textarea
                        className="sf-staff-input tall-description"
                        value={local.bio}
                        onChange={(e) => {
                            setLocal({ ...local, bio: e.target.value });
                            e.target.style.height = "auto";
                            e.target.style.height = e.target.scrollHeight + "px";
                        }}
                    />
                </div>

                <div className="sf-base-footer">
                    <button className="btn ghost" onClick={onClose}>
                        {translations[language].calendar.editor.cancel}
                    </button>
                    <button className="btn" onClick={handleSave} disabled={saving}>
                        {saving
                            ? translations[language].calendar.editor.saving
                            : translations[language].calendar.editor.save}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StaffInfoModal;